import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NotificationItem } from '@ps/notification-models';

export const NotificationActions = createActionGroup({
  source: 'Notification',
  events: {
    Refresh: emptyProps(),
    'Load Notifications': emptyProps(),
    'Load Unseen Count': emptyProps(),
    'Mark All Viewed': emptyProps(),
    'Mark Viewed': props<{ notificationId: string; viewed: boolean }>(),
  },
});

export const NotificationApiActions = createActionGroup({
  source: 'Notification API',
  events: {
    'Load Notifications Started': emptyProps(),
    'Load Notifications Success': props<{
      notifications: NotificationItem[];
      cachedAt: number;
    }>(),
    'Load Notifications Failure': props<{ error: string }>(),
    'Load Unseen Count Success': props<{
      unseenCount: number;
      cachedAt: number;
    }>(),
    'Load Unseen Count Failure': props<{ error: string }>(),
    'Mark All Viewed Success': props<{ changed: number }>(),
    'Mark All Viewed Failure': props<{ error: string }>(),
    'Mark Viewed Success': props<{ notification: NotificationItem }>(),
    'Mark Viewed Failure': props<{ error: string }>(),
  },
});
